var React = require('react');

function MyHealth (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m1.926 22.5-.02-.001a1.362 1.362 0 0 1-.5-.133.685.685 0 0 1-.274-.23C1.073 22.05 1 21.889 1 21.584c0-.701.38-2.361 1.863-3.845 1.455-1.454 4.056-2.821 8.637-2.821 4.58 0 7.182 1.367 8.637 2.821C21.62 19.222 22 20.882 22 21.583c0 .305-.073.466-.131.554a.686.686 0 0 1-.274.229 1.362 1.362 0 0 1-.5.133l-.021.001H1.926ZM14.86 9.609A4.75 4.75 0 1 1 8.14 2.89a4.75 4.75 0 0 1 6.72 6.72Z","stroke":"#00A098","strokeWidth":"2"}));
}

MyHealth.defaultProps = {"fill":"none","viewBox":"0 0 23 24"};

module.exports = MyHealth;

MyHealth.default = MyHealth;
